import React from 'react'
import './DecathlonSection.css'
import decathlon from './assets/decathlon_digital.png'


function DecathlonSection () {
  return(
    <div  className="Decathlon-section">
      <div className="Decathlon-image">
          <img width="100%" height="100%" src={decathlon} alt="decathlon" />
      </div>
      <div className="Decathlon-subsection">
        <div className="Decathlon-container">
          <h4>
            <p>Depuis plus de 40 ans, grâce à ses produits innovants et fort de sa culture reposant sur l’accessibilité, Decathlon ne cesse de réinventer le marché du sport. Notre mission : rendre durablement les plaisirs et les bienfaits du sport accessibles au plus grand nombre.</p>
            <p>Aujourd'hui, Decathlon Digital tire  parti de cette culture de l'innovation et de l’expertise digitale de ses teammates  pour qu’un public plus large puisse bénéficier des plaisirs du sport et ce, à l'aide de la technologie. Notre objectif: créer un écosystème digital de produits et services en nous positionnant comme créateurs  de nouvelles expériences pour les sportif·ve·s – coaching virtuel, programmes de fidélité, expériences intelligentes en magasin, offres de produits neufs et d'occasion, mais aussi services de location d'une large gamme de produits Decathlon et de partenaires.</p>
            <p>Nos équipes tech françaises implantées à Paris (Global Business Hub) etLille (HQ), rassemblent plus de 2500 software engineers, product managers et expert·e·s de la data, uni·e·s pour construire et faire évoluer nos produits dont le but unique est de répondre aux besoins de nos 500 millions d'utilisateurs.</p>
            <a href="https://www.welcometothejungle.com/fr/companies/decathlon-technology">Pour en savoir plus...</a>
          </h4>
        </div>
      </div>
    </div>
  )
}

export default DecathlonSection
